module.exports = __webpack_public_path__ + "static/media/printStep4.dfe28c50.png";